module.exports = "<p>\n  statutory-clearances works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/statutory-clearances/statutory-clearances.component.html
// module id = ./src/app/planning/statutory-clearances/statutory-clearances.component.html
// module chunks = main